import { matchPath } from 'react-router-dom';
import { stripLanguageFromPath } from '../../utils/languageUtils';

// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path ? path.includes('http') : false;
}

export function getActive(path, pathname) {
  // Strip language prefix from pathname before matching
  // This allows paths like "/dashboard/mycolab" to match "/en/dashboard/mycolab"
  const pathnameWithoutLang = stripLanguageFromPath(pathname);
  return path ? !!matchPath({ path, end: false }, pathnameWithoutLang) : false;
}
